import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 76 77",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 5.462C0 2.446 2.507 0 5.599 0h64.569c3.092 0 5.599 2.446 5.599 5.462v65.324c0 3.017-2.507 5.462-5.599 5.462H5.599C2.507 76.248 0 73.803 0 70.786V5.462Zm29.3 58.365h11.444V44.6c0-1.029.074-2.057.376-2.792.827-2.056 2.71-4.186 5.872-4.186 4.141 0 5.797 3.158 5.797 7.786v18.419h11.443V44.086c0-10.576-5.645-15.497-13.175-15.497-6.07 0-8.792 3.337-10.313 5.683v.119h-.077l.077-.119v-4.875H29.3c.15 3.231 0 34.43 0 34.43Zm-6.333 0v-34.43H11.523v34.43h11.444Zm-5.722-39.131c3.991 0 6.475-2.643 6.475-5.948-.074-3.378-2.484-5.948-6.399-5.948s-6.474 2.57-6.474 5.948c0 3.305 2.483 5.948 6.324 5.948h.074Z",
  style: {"fill-rule":"nonzero"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }